import { defaultPinTheme, PinViewerStatic } from '@lessonup/pin-renderer';
import { PinTheme, TeacherPin } from '@lessonup/pins-shared';
import { LessonPin } from '@lessonup/teaching-core';
import { PinView } from '@lessonup/typescript-core/ui';
import React, { useCallback } from 'react';
import './lessonPreviewTile.less';

export interface LessonPreviewTilePropsv1 {
  pins: LessonPin[];
  totalPinCount: number;
}

export const LessonPreviewTileV1: React.FC<LessonPreviewTilePropsv1> = ({ pins, totalPinCount }) => {
  const firstPin = pins[0];

  if (!firstPin) {
    return null;
  }

  const totalPins = pins.length;
  const remainingPinsToShow = pins.slice(1, 4);

  return (
    <div className="lesson-preview-tile">
      <div className="lesson-preview-tile--initialPin">
        <PinView pin={firstPin} isThumb hideFact />
      </div>
      <div className="lesson-preview-tile--lowerpin-list">
        {totalPins >= 2 && (
          <>
            {remainingPinsToShow.map((pin) => (
              // eslint-disable-next-line react/jsx-key -- auto-generated TECH-258
              <div className="lesson-preview-tile--lowerpin">
                <PinView pin={pin} isThumb hideFact />
              </div>
            ))}
            <OtherPinsIndicator value={totalPinCount - 4} />
          </>
        )}
      </div>
    </div>
  );
};

export interface LessonPreviewTilePropsv2 {
  teacherPins: TeacherPin[];
  totalPinCount: number;
  pinThemes: PinTheme[];
}

export const LessonPreviewTileV2: React.FC<LessonPreviewTilePropsv2> = ({ teacherPins, totalPinCount, pinThemes }) => {
  const getPinThemeById = useCallback(
    (pinThemeId?: string) => pinThemes.find((pinTheme) => pinTheme.id === pinThemeId) ?? defaultPinTheme,
    [pinThemes]
  );
  const firstPin = teacherPins[0];

  if (!firstPin) {
    return null;
  }

  const totalPins = teacherPins.length;
  const remainingPinsToShow = teacherPins.slice(1, 4);

  return (
    <div className="lesson-preview-tile lesson-preview-tile--v2-container">
      <div className="lesson-preview-tile--initialPin lesson-preview-tile--v2">
        <PinViewerStatic pin={firstPin} width={231} pinTheme={getPinThemeById(firstPin.settings.pinThemeId)} />
      </div>
      <div className="lesson-preview-tile--lowerpin-list">
        {totalPins >= 2 && (
          <>
            {remainingPinsToShow.map((pin) => (
              <div key={pin.id} className="lesson-preview-tile--lowerpin lesson-preview-tile--v2">
                <PinViewerStatic pin={pin} width={56} pinTheme={getPinThemeById(pin.settings.pinThemeId)} />
              </div>
            ))}
            <OtherPinsIndicator value={totalPinCount - 4} />
          </>
        )}
      </div>
    </div>
  );
};

const OtherPinsIndicator: React.FC<{ value: number }> = ({ value }) => {
  if (value <= 0) {
    return null;
  }
  return (
    <div className="lesson-preview-tile__count">
      <div className="lesson-preview-tile__count-text">{value <= 99 ? `+${value}` : `99+`}</div>
    </div>
  );
};
